import { EventComment } from '../../../../features/live-events/types/TrackingEvents'
import { InternalTrackingEventEvent } from '../../../types/InternalTrackingEvent'

export const emptyEventComment = (): EventComment => ({
  analystId: '',
  content: { comment: { en: '', ja: '', zh: '' } },
})

/**
 * The edit form's name, comment and game for a loaded event. The backend leaves out an event's name,
 * comment and game id when they have no value, while the name field and the analyst select need
 * defined values to stay controlled and a save must carry the game it belongs to, which is the
 * game the page was opened for.
 */
export const eventEditFormBasics = (
  event: Pick<InternalTrackingEventEvent, 'gameId' | 'name' | 'comment'>,
  trackedGameId: string
): { gameId: string; name: string; comment: EventComment } => ({
  gameId: event.gameId ?? trackedGameId,
  name: event.name ?? '',
  comment: event.comment ?? emptyEventComment(),
})
